import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import 'formdata-polyfill';

import configureStore from './store';
import App from './containers/App';

/**
 * Minifig builder entry point
 *
 * @author John Noel <john.noel@joipolloi.com>
 * @package Minifigs
 */

const store = configureStore(window.__INITIAL_STATE__);

const container = document.getElementById('app');
if (container) {
    const root = createRoot(container);
    root.render(
        <Provider store={store}>
            <App />
        </Provider>
    );
}
